import React from 'react'

//styles
import ProductClientView from '../../components/productClientView/ProductClientView'

const Products = () => {
  return (
    <ProductClientView />
  )
}

export default Products